import wrapper from 'wrapper';

/**
 * Class to reveal and hide a floating button
 * On scroll, the button will appear when the target element is out of view
 *
 * @class FloatingButton
 */
class FloatingButton {
    constructor(containerSelector, buttonSelector, targetId, { scrollTo, offset }) {
        this.profileContainer = wrapper.select(containerSelector);
        this.button = wrapper.select(buttonSelector);
        this.scrollTarget = wrapper.scope.getElementById(targetId);
        this.showButton = false;

        this.offset = offset || 0;
        this.buffer = 200;

        // set sticky styles
        this.button.style.position = 'sticky';
        // TODO: fix scrollTo functionality on news app (may require separate .app include so that we can detect the app)
        // if (scrollTo) {
        //     this.height = this.button.offsetHeight;
        //     this.button.style.top = `calc(100vh - ${this.height + convertRemToPixels(this.offset)}px)`;
        // }
        // else {
        //     this.button.style.bottom = `${this.offset}rem`;
        // }

        this.button.addEventListener('click', (e) => {
            wrapper.trackUserAction('button clicked', e.target.dataset.desc);
        });

        wrapper.onRawScroll(() => {
            this.showButton = (scrollTo) ? this.scrollTarget.getBoundingClientRect().top > window.innerHeight : this.scrollTarget.getBoundingClientRect().top + this.buffer < 0;
            this.button.classList.toggle('show-btn', this.showButton);
            this.button.classList.toggle('hide-btn', !this.showButton);
        });
    }
}

export default FloatingButton;

function convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
